import { ControllerBase, modules } from "./base";

export class AuthBase extends ControllerBase {
    emailAddress = "";
    password = "";
    error = "";
    message = "";

    constructor(options = params) {
        super({
            modules: {
                ...options.modules
            },
            required_modules: {
                auth: true
            }
        })
    }

    async loginWithEmailAndPassword() {
        this.loading = true;
        this.message = "Logging in...";
        let response = await this.auth.loginWithEmailAndPassword(this.emailAddress, this.password);
        this.loading = false;

        // DO VALIDATION LOGIC HERE
        if (response == null) {
            this.error = "there was an error logging in";
        } else {
            if (response.success) {
                localStorage.setItem("token", response.data)
                this.onLoggedIn();
                this.afterLogin();
            } else {
                this.error = response.errors[0];
            }
        }
    }

    async verifyLogin() {
        let response = await this.auth.verifyLogin();
        return response;
    }

    // OVERRIDES
    onLoggedIn() {
    }

    afterLogin() {
    }
}

const params = {
    modules: {
        ...modules
    }
}